package one.healthium.domain.common


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


@Serializable
data class ReviewItem(
    @SerialName("author") val author: String? = null,
    @SerialName("rating") val rating: String? = null,
    @SerialName("review") val review: String? = null,
)